import { useTranslation } from 'react-i18next'

import { useUserOrganization } from '@modules-deprecated/app/organization'

import { getCountryTaxFieldData } from '../utils/getCountryTaxFieldData'

export interface ResolvedLabel {
  vatNoLabel?: string
  registrationNoLabel: string
}

/**
 * Hook to resolve tax number and registration number based on organization country - not language.
 * Returns an object with labels for tax id and registration number fields.
 */
export const useResolveTaxAndRegistrationNoLabel = (): ResolvedLabel => {
  const { organization } = useUserOrganization()
  const { t } = useTranslation()

  const countryId = organization?.countryId
  const countryTaxData = countryId ? getCountryTaxFieldData(countryId) : undefined

  const vatNoLabel = countryTaxData?.vatNo?.label
  const registrationNoLabel =
    countryTaxData?.registrationNo.label ??
    t('settings.organization.organization_info.basic_info.registration_number.label')

  return { vatNoLabel, registrationNoLabel }
}
